import { DashedSquareIcon } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-icons/dashed-square-icon';
import type { SlashMenuItem } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/slash-dropdown-menu/use-slash-dropdown-menu';
import { isNodeInSchema } from '@examdojo/core/tiptap-react-ui-components/lib/tiptap-utils';
import type { Editor } from '@tiptap/react';
import { KEY_POINT_CALLOUT_NODE_NAME } from './extensions/key-point-callout';

export const STUDY_NOTES_SLASH_MENU_ITEMS: Record<string, SlashMenuItem> = {
  keypointCallout: {
    metadata: {
      title: 'Key Point',
      subtext: 'Highlighted key point box',
      keywords: ['keypoint', 'key point', 'callout'],
      badge: DashedSquareIcon,
      group: 'Study notes',
    },
    implementation: {
      check: (editor: Editor) => isNodeInSchema(KEY_POINT_CALLOUT_NODE_NAME, editor),
      action: ({ editor }: { editor: Editor }) => {
        editor
          .chain()
          .focus()
          .insertContent({
            type: KEY_POINT_CALLOUT_NODE_NAME,
            attrs: {
              title: 'Key Point',
              color: 'yellow',
              icon: 'key',
            },
            content: [{ type: 'paragraph' }],
          })
          .run();
      },
    },
  },
};
